import { inputToTags, tagsToInput } from "../../mst/kinds/utils";
import { OptimisticConcurrency } from "../../schema/types/base";
import { User } from "../../schema/types/user/entity";
import { UserInput } from "../../schema/types/user/input";

export function getDefaultUserInput(): UserInput {
  return {
    version: 0,
    id: "",
    tags: [],
    meta: {
      isEdit: false,
    },
  };
}

export function userToInput(user: User): UserInput {
  const def = getDefaultUserInput();
  const res: UserInput = {
    ...def,
    version: user.version,
    id: user.id,
    tags: tagsToInput(user.tags),
    meta: {
      ...def.meta,
      isEdit: true,
    },
  };
  return res;
}

export function inputToUser(input: UserInput): Partial<User> {
  const res: Partial<User> = {
    tags: inputToTags(input.tags),
  };
  return res;
}

export function userToPatch(_user: Partial<User>, concurrency: OptimisticConcurrency) {
  const user: any = JSON.parse(JSON.stringify(_user));

  user[`$replace/tags`] = user.tags;
  delete user.tags;

  user.id = concurrency.id;
  user.version = concurrency.version;

  return user;
}
